<template>
  <div>
    <div v-for="{ id, img, description } in items" :key="id" :class="id === activeTab ? 'block' : 'hidden'">
      <img class="w-full" :src="img" />

      <div class="text-center">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import HighlightingImg from '@/assets/images/feature-highlight.png'
import SocialMediaPushImg from '@/assets/images/feature-network-push.png'
import RefreshHalftimeImg from '@/assets/images/feature-refresh-15.png'
import Refresh30Img from '@/assets/images/feature-refresh-30.png'
import TopJobImg from '@/assets/images/feature-topjob.png'
import { JOB_FEATURE } from '@/helpers/constants'

import { useNuxtApp } from '#imports'

interface JobWizardStepFeaturesTabsContentProps {
  activeTab: string
}

defineProps<JobWizardStepFeaturesTabsContentProps>()

const { $i18n } = useNuxtApp()

const items = computed(() => [
  {
    id: JOB_FEATURE.SOCIAL_MEDIA_PUSH,
    img: SocialMediaPushImg,
    description: $i18n.t('new_job_landing.features.description.social_media_push'),
  },
  {
    id: JOB_FEATURE.REFRESH_HALFTIME,
    img: RefreshHalftimeImg,
    description: $i18n.t('new_job_landing.features.description.halftime'),
  },
  {
    id: JOB_FEATURE.REFRESH_30,
    img: Refresh30Img,
    description: $i18n.t('new_job_landing.features.description.refresh_30'),
  },
  {
    id: JOB_FEATURE.TOP_JOB,
    img: TopJobImg,
    description: $i18n.t('new_job_landing.features.description.top_job'),
  },
  {
    id: JOB_FEATURE.HIGHLIGHTING,
    img: HighlightingImg,
    description: $i18n.t('new_job_landing.features.description.highlighting'),
  },
])
</script>
